var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResume2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 17q-.425 0-.712-.288Q21 16.425 21 16v-5.9l-8.025 4.375q-.225.125-.463.187-.237.063-.512.063t-.512-.063q-.238-.062-.463-.187L2.6 9.875q-.25-.125-.387-.363-.138-.237-.138-.512t.138-.512q.137-.238.387-.363l8.45-4.6q.225-.125.462-.188.238-.062.488-.062t.488.062q.237.063.462.188l9.525 5.2q.25.125.388.362.137.238.137.513V16q0 .425-.288.712Q22.425 17 22 17Zm-10 3.725q-.25 0-.488-.062-.237-.063-.462-.188l-5-2.7q-.5-.275-.775-.737Q5 16.575 5 16v-3.8l5.675 3.075q.325.175.65.312.325.138.675.138.35 0 .688-.15.337-.15.662-.325L19 12.2V16q0 .575-.275 1.038-.275.462-.775.737l-5 2.7q-.225.125-.462.188-.238.062-.488.062Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume2);
export default __webpack_public_path__ + "static/media/resume2.27618d5a49fcb528a9d015ba2fc7eca4.svg";
export { ForwardRef as ReactComponent };